import { USERS_METRICS } from 'modules/billing/constants';

export const USERS_CARD_IDS = {
  cardId: 'users-metrics',
};

export const USERS_CARD_TEXT = {
  activeUsersAddedInPeriodName: 'Active users added',
  cardTitle: 'Users',
  projectBreakdownUrl: '/payments/info/audienceUsage',
  totalUsersAllTimeDescription: 'Total number of users as of',
  totalUsersAllTimeName: 'User count',
  totalUsersAddedInPeriodDescription: 'All users added within the given date range.',
  totalUsersAddedInPeriodName: 'Users added',
  totalUsersHighWatermarkDescription: 'Highest number of users recorded between',
  totalUsersHighWatermarkName: 'High water mark',
};

export const USERS_METRIC_NAMES = [
  USERS_METRICS.totalUsersHighWatermark,
  USERS_METRICS.totalUsersAllTime,
  USERS_METRICS.totalUsersAddedInPeriod,
  USERS_METRICS.activeUsersAddedInPeriod,
];
